import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Marketplace.css"; // Adjust the path if needed

const Marketplace = () => {
  return (
    <>
      <Navbar />
      <div className="marketplace-container" style={{ textAlign: "center", padding: "100px 20px" }}>
       
        <h1 style={{ fontSize: "2.5rem", marginTop: "20px", color: "#ff6500" }}>Exciting things are on the way!</h1>
      </div>
      <Footer />
    </>
  );
};

export default Marketplace;